export enum EnumTpDescontoAcrescimo {
    Porcentagem = 0,
    ValorFixo = 1,
}